module.exports = __webpack_public_path__ + "img/48.be192f3b.jpg";